$(window).on("load", function () {
  //ページ内リンク
  var headerHeight = $('.header').outerHeight();
  var urlHash = location.hash;
  if (urlHash) {
    var position = $(urlHash).offset().top - headerHeight;
    $("html, body").animate({ scrollTop: position }, 0);
  }
});

jQuery(function ($) {
  $(window).on("scroll", function () {
    var pos = $(".content").offset();
    if ($(this).scrollTop() > pos.top) {
      $("header.is-top").addClass("is-active");
      $("header.is-top").fadeIn();
    } else {
      $("header.is-top").removeClass("is-active");
      $("header.is-top").fadeOut();
    }
  });

  $(".hamburger, .close, .global-nav li").on("click", function () {
    $(".header-nav").toggleClass("is-shown");
    $("body").toggleClass("is-open");
  });

  //ページ内リンク
  $('.global-nav li a, .footer-main__nav li a').on("click",function(e) {
    // デフォルトの挙動（リンク先へのジャンプ）をキャンセル
    // e.preventDefault();
    // 遷移先のセレクタを取得
    var target = $(this.hash);
    console.log(target);
    // ヘッダーの高さを取得
    if(target){
      var headerHeight = $('.header').outerHeight();
      // 遷移先の位置を取得し、ヘッダーの高さを減算
      var offset = $(target).offset().top - headerHeight;
      
      // スクロールを実行（アニメーションあり）
      $('html, body').animate({
          scrollTop: offset
      }, 500);
    }
  });
});
